module.exports = __webpack_public_path__ + "img/bakingIngredient13.f982365a.jpeg";